import { SET_FORECAST_FREE_CASH_FLOW } from "./mutations";
import {store} from "../../index";
import ForecastedFreeCashFlow, {
  ForecastedFreeCashFlowBeforeTax,
  ForecastedFreeCashFlowAfterTax
} from "../../../models/valuation/ForecastedFreeCashFlow";
import {generateForecastedDepreciation} from "../forecastDepreciation/actions";
import {generateForecastedDOE} from "../valuation/actions";
import {generateForecastRC} from "../forecastRC/actions";
import {generateForecastedGWC} from "../forecastGWC/actions";
import {generateForecastMaintenanceAndGrowthCapex} from "../forecastMGC/actions";


export const generateForecastFreeCashFlow = () => (dispatch) => {
  dispatch(generateForecastedDOE())
  dispatch(generateForecastRC())
  dispatch(generateForecastedGWC())
  dispatch(generateForecastMaintenanceAndGrowthCapex())
  dispatch(generateForecastedDepreciation())

  const {
    forecastMGC,
    forecastGWC,
    forecastRC,
    forecastDepreciation,
    taxes
  } = store.getState()
  const { forecastedDOE } = store.getState().valuation;
  const { currentForecastRC } = forecastRC

  dispatch({
    type: SET_FORECAST_FREE_CASH_FLOW,
    payload: new ForecastedFreeCashFlow({
      forecastedFreeCashFlowBeforeTax: new ForecastedFreeCashFlowBeforeTax({
        forecastedOwnerDiscretionaryEarnings: forecastedDOE?.forecastedDOE,
        reasonableCompensation: currentForecastRC?.forecastedReasonableCompensation,
        growthWorkingCapital: forecastGWC?.currentForecastGWC?.requiredAnnualInvestment,
        capitalExpenditures: forecastMGC?.forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex
      }),
      forecastedFreeCashFlowAfterTax: new ForecastedFreeCashFlowAfterTax({
        forecastedOwnerDiscretionaryEarnings: forecastedDOE?.forecastedDOE,
        depreciation: forecastDepreciation?.forecastedDepreciation.forecastedValue,
        reasonableCompensation: currentForecastRC?.forecastedReasonableCompensation,
        addDepreciation: forecastDepreciation?.forecastedDepreciation.forecastedValue,
        growthWorkingCapital: forecastGWC?.currentForecastGWC?.requiredAnnualInvestment,
        capitalExpenditures: forecastMGC?.forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex,
        stateTax: taxes.stateTax,
        federalTax: taxes.federalTax
      })
    })
  })
}